import { cn } from '@/lib/utils';
import { useScrollAnimation } from '@/hooks/useScrollAnimation';

interface QuoteBannerProps {
  quote: string;
  className?: string;
}

export function QuoteBanner({ quote, className }: QuoteBannerProps) {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section className={cn('relative py-10 md:py-16 lg:py-24 overflow-hidden', className)}>
      {/* Background */}
      <div className="absolute inset-0 bg-primary" />
      <div 
        className="absolute inset-0 opacity-5"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }}
      />
      
      <div className="container-custom relative z-10 px-6 md:px-4">
        <div 
          ref={ref}
          className={cn(
            "mx-auto max-w-4xl text-center opacity-0",
            isVisible && "animate-blur-in"
          )}
          style={{ animationFillMode: 'forwards' }}
        >
          <blockquote>
            <p className="font-display text-base sm:text-lg md:text-2xl lg:text-3xl leading-relaxed text-primary-foreground md:whitespace-nowrap">
              "{quote}"
            </p>
          </blockquote>
        </div>
      </div>
    </section>
  );
}
